import React, { useState } from "react";
import { Brain, ChevronDown, ChevronUp } from "lucide-react";
import type { AgentStreamUpdate } from "@/lib/types";

interface DeepThinkingIndicatorProps {
  logs: AgentStreamUpdate[];
  status: string;
  progress?: number;
  isStreaming?: boolean;
}

const DeepThinkingIndicator: React.FC<DeepThinkingIndicatorProps> = ({
  logs,
  status,
  isStreaming,
}) => {
  const [showLogs, setShowLogs] = useState(false);
  const isRunning = (status === "running" || status === "pending") && isStreaming !== false;

  return (
    <div className="deep-thinking-indicator">
      <div className="deep-thinking-header">
        <div className="deep-thinking-badge">
          <Brain size={14} className={`deep-thinking-icon ${isRunning ? "running" : "completed"}`} />
          <span>Deep Thinking</span>
          {isRunning && (
            <div className="deep-thinking-dots">
              <span className="dot" />
              <span className="dot" />
              <span className="dot" />
            </div>
          )}
        </div>
        {logs.length > 0 && (
          <button
            className="deep-thinking-toggle-logs"
            onClick={() => setShowLogs(!showLogs)}
          >
            {showLogs ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
            {showLogs ? "Hide Logs" : "Show Logs"}
          </button>
        )}
      </div>
      {showLogs && logs.length > 0 && (
        <div className="deep-thinking-logs">
          {logs.map((log, i) => (
            <div key={i} className="deep-thinking-log-entry">
              <span className="log-status">{log.status?.toUpperCase()}</span>
              <span className="log-message">{log.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeepThinkingIndicator;
